import React, { useState } from 'react';
import { FadeIn } from './FadeIn';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function FaqSection() {
  const faqs = [{
    q: '¿Es una dieta estricta?',
    a: 'No, es un ajuste de señales nutricionales.'
  }, {
    q: '¿Necesito suplementos caros?',
    a: 'No, la base es comida real, los suplementos son solo un apoyo opcional.'
  }, {
    q: '¿Cuánto tiempo toma ver resultados?',
    a: 'La mayoría nota menos inflamación en la primera semana.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-20 bg-white" data-id="element-46">
      <div className="container mx-auto px-6 max-w-3xl" data-id="element-47">
        <FadeIn data-id="element-48">
          <div className="text-center mb-12" data-id="element-49">
            <h2 className="text-3xl md:text-4xl font-bold text-forest mb-4" data-id="element-50">
              Preguntas Frecuentes
            </h2>
            <div className="w-24 h-1 bg-sage mx-auto rounded-full" data-id="element-51"></div>
          </div>
        </FadeIn>

        <div className="space-y-4" data-id="element-52">
          {faqs.map((faq, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-53">
              <div className="border border-sage-light rounded-2xl overflow-hidden bg-cream/50" data-id="element-54">
                <button className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-55">
                  <span className="font-bold text-forest text-lg" data-id="element-56">{faq.q}</span>
                  <motion.div animate={{
                rotate: openIndex === index ? 180 : 0
              }} transition={{
                duration: 0.3
              }} data-id="element-57">
                    <ChevronDown className="text-sage w-6 h-6" data-id="element-58" />
                  </motion.div>
                </button>
                <AnimatePresence data-id="element-59">
                  {openIndex === index && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3
              }} data-id="element-60">
                      <div className="px-6 pb-5 text-forest/70 text-lg" data-id="element-61">
                        {faq.a}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}